import {
  DELETE_COURIER_REQUEST,
  DELETE_COURIER_SUCCESS,
  DELETE_COURIER_FAILURE,
} from "../actions";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

const addCourierListByAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_COURIER_REQUEST:
      return {
        ...state,
        loading: true,
        data: [],
      };

    case DELETE_COURIER_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: "",
      };
    case DELETE_COURIER_FAILURE:
      return {
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default addCourierListByAdminReducer;
